import React, { useEffect, useRef, useState } from 'react';

import { Tooltip } from '@mescius/wijmo';
import _ from 'lodash';
import { isIPad } from '../../../utilities/commonUtil';

const CellContent = ({
  children,
  errorMsg = '',
  isDataChanged = false,
  errorTooltipId,
}) => {
  const [className, setClassName] = useState('');
  const errorTool = useRef(null);
  const cell = useRef(null);

  const transformMsgError = () => {
    let message = '';
    const msgErrors = errorMsg.split(' ');
    message = _.join(msgErrors, '\n');
    return message;
  };

  useEffect(() => {
    errorTool.current = new Tooltip({
      isContentHtml: false,
      position: 11,
      gap: 3,
      showDelay: 0,
      cssClass: 'wj-tooltip-multiple-edit-work',
    });
  }, []);

  useEffect(() => {
    let cssClass = '';
    if (errorMsg) {
      cssClass = 'wj-validate-invalid';
      if (isIPad()) {
        cell.current.addEventListener('click', handleShowTooltip);
        document.addEventListener('touchmove', handleTouchmove);
      } else {
        errorTool.current.setTooltip(`#${errorTooltipId}`, transformMsgError());
      }
    } else if (isDataChanged) {
      cssClass = 'wj-bg-yellow';
      errorTool.current.dispose();
      if (isIPad()) {
        cell.current.addEventListener('click', () => errorTool.current.hide());
      }
    }
    setClassName(cssClass);
    return () => {
      setClassName('');
      if (cell.current) {
        cell.current.removeEventListener('click', () => handleShowTooltip);
        cell.current.removeEventListener('click', () =>
          errorTool.current.hide()
        );
      }
      document.removeEventListener('touchmove', handleTouchmove);
    };
  }, [errorMsg, isDataChanged]);

  const handleShowTooltip = () =>
    errorTool.current.show(`#${errorTooltipId}`, transformMsgError());

  const handleTouchmove = () => {
    errorTool.current.hide();
    const input = document.querySelectorAll(`#${errorTooltipId} input`);
    const textarea = document.querySelectorAll(`#${errorTooltipId} textarea`);
    if (input && input.length > 0) {
      input[0].blur();
    }
    if (textarea && textarea.length > 0) {
      textarea[0].blur();
    }
  };

  return (
    <div
      id={errorTooltipId}
      className={['wj-wrapper-content', className].join(' ')}
      ref={cell}
    >
      {children}
    </div>
  );
};

export default CellContent;



// WEBPACK FOOTER //
// ./src/components/wijimo/templates/CellContent.jsx